<template>
	<div class="CommonBody" :class="{ 'is-mobile-menu-open': menuOpen, 'is-mobile': isMobile }">
		<el-container class="common_box">
			<el-header class="common_header">
				<el-row type="flex" justify="space-between" align="middle" class="common_header_main">
					<el-row type="flex" align="middle" class="common_header_l">
						<button
							type="button"
							class="common_header_menu"
							aria-label="打开菜单"
							@click="toggleMenu">
							<i class="el-icon-menu" aria-hidden="true"></i>
						</button>
						<div class="common_header_logo">
							<img src="@/assets/maitu-logo.svg" alt="logo" />
						</div>
						<div class="common_header_title">定制家居产品供应链管理</div>
					</el-row>
					<el-row type="flex" align="middle" class="common_header_r">
						<div class="common_header_user">
							<span class="common_header_avatar">{{ userInitial }}</span>
							<span class="common_header_name">{{ userInfo.nickname }}</span>
						</div>
						<button type="button" class="common_header_btn" @click="loginOut">退出登录</button>
					</el-row>
				</el-row>
			</el-header>
			<el-container class="common_content">
				<div class="common_aside_overlay" @click="closeMenu" aria-hidden="true"></div>
				<el-aside class="common_aside">
					<nav class="common_aside_main">
						<div v-if="ruleList.goods" @click="goUrl" data-index="1" data-url="/typeList" class="common_aside_item" :class="{'common_aside_active': aside==1}">
							<div class="common_aside_icon common_aside_img">
								<img src="../../assets/img/list.png" alt="" />
							</div>
							<div class="common_aside_name">产品列表</div>
						</div>
						<div v-if="ruleList.customer" @click="goUrl" data-index="2" data-url="/customer" class="common_aside_item" :class="{'common_aside_active': aside==2}">
							<div class="common_aside_icon common_aside_img">
								<img src="../../assets/img/user.png" alt="" />
							</div>
							<div class="common_aside_name">客户信息</div>
						</div>
						<div v-if="ruleList.order_add" @click="goUrl" data-index="3" data-url="/quotation" class="common_aside_item" :class="{'common_aside_active': aside==3}">
							<div class="common_aside_icon common_aside_img">
								<img src="../../assets/img/bjd.png" alt="" />
							</div>
							<div class="common_aside_name">创建报价</div>
						</div>
						<div v-if="ruleList.order" @click="goUrl" data-index="4" data-url="/offer" class="common_aside_item" :class="{'common_aside_active': aside==4}">
							<div class="common_aside_icon common_aside_img">
								<img src="../../assets/img/bjcx.png" alt="" />
							</div>
							<div class="common_aside_name">我的报价</div>
						</div>
						<div v-if="ruleList.deliver_goods" @click="goUrl" data-index="5" data-url="/delivery" class="common_aside_item" :class="{'common_aside_active': aside==5}">
							<div class="common_aside_icon common_aside_img">
								<img src="../../assets/img/fhcx.png" alt="" />
							</div>
							<div class="common_aside_name">我的订单</div>
						</div>
						<div v-if="ruleList.factory_list" @click="goUrl" data-index="6" data-url="/factory" class="common_aside_item" :class="{'common_aside_active': aside==6}">
							<div class="common_aside_icon common_aside_img">
								<img src="../../assets/img/fhcx.png" alt="" />
							</div>
							<div class="common_aside_name">生产查询</div>
						</div>
						<div v-if="ruleList.order_stats" @click="goUrl" data-index="8" data-url="/orderStats" class="common_aside_item" :class="{'common_aside_active': aside==8}">
							<div class="common_aside_icon common_aside_img">
								<img src="../../assets/img/bjcx.png" alt="" />
							</div>
							<div class="common_aside_name">订单统计</div>
						</div>
						<div
							v-for="group in visibleAdminGroups"
							:key="group.key"
							class="common_aside_group"
							:class="{ 'is-open': isGroupOpen(group.key), 'is-current': isGroupActive(group) }">
							<div class="common_aside_item" @click="toggleGroup(group)">
								<div class="common_aside_icon common_aside_img">
									<img :src="groupIcon(group.icon)" alt="" />
								</div>
								<div class="common_aside_name">{{ group.title }}</div>
								<i class="el-icon-arrow-down common_aside_arrow" aria-hidden="true"></i>
							</div>
							<div v-show="isGroupOpen(group.key)" class="common_aside_subs">
								<div
									v-for="child in group.children"
									:key="child.url"
									class="common_aside_sub"
									:class="{ 'common_aside_sub_active': isActiveUrl(child.url) }"
									@click="goChild(child.url)">
									{{ child.title }}
								</div>
							</div>
						</div>
						<div v-if="ruleList.user" @click="goUrl" data-index="7" data-url="/center" class="common_aside_item" :class="{'common_aside_active': aside==7}">
							<div class="common_aside_icon common_aside_img">
								<img src="../../assets/img/center.png" alt="" />
							</div>
							<div class="common_aside_name">个人中心</div>
						</div>
					</nav>
				</el-aside>
				<el-main class="common_main">
					<slot name="commonMain"></slot>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import { applyMobileViewport } from '@/utils/isMobile'
	import { stripElementModals } from '@/utils/element-overlay'
	import { FRONT_SIDEBAR_GROUPS } from '@/utils/front-admin-catalog'

	const GROUP_ICONS = {
		'list.png': require('../../assets/img/list.png'),
		'center.png': require('../../assets/img/center.png'),
		'user.png': require('../../assets/img/user.png'),
		'bjcx.png': require('../../assets/img/bjcx.png'),
	}

	export default {
		name: 'CommonBody',
		props: {
			aside: {
				type: String,
				default: '1'
			},
			backStatus: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
				userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
				ruleList: JSON.parse(localStorage.getItem('ruleList') || '{}'),
				menuOpen: false,
				isMobile: false,
				openGroups: {},
			}
		},
		created() {
			this.isMobile = applyMobileViewport()
			this.syncOpenGroups()
		},
		mounted() {
			this.isMobile = applyMobileViewport()
			window.addEventListener('resize', this.syncMobile)
			window.addEventListener('orientationchange', this.syncMobile)
			if (window.visualViewport) {
				window.visualViewport.addEventListener('resize', this.syncMobile)
			}
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.syncMobile)
			window.removeEventListener('orientationchange', this.syncMobile)
			if (window.visualViewport) {
				window.visualViewport.removeEventListener('resize', this.syncMobile)
			}
		},
		watch: {
			'$route'() {
				this.menuOpen = false
				this.syncOpenGroups()
			},
		},
		computed: {
			userInitial() {
				const name = this.userInfo && this.userInfo.nickname;
				if (!name) return 'U';
				return String(name).charAt(0);
			},
			visibleAdminGroups() {
				return FRONT_SIDEBAR_GROUPS.filter((g) => this.showAdminModule(g.rule))
			},
		},
		methods: {
			showAdminModule(key) {
				return !!(this.ruleList[key] || this.ruleList.goods_manage)
			},
			groupIcon(name) {
				return GROUP_ICONS[name] || GROUP_ICONS['list.png']
			},
			isActiveUrl(url) {
				const qIndex = url.indexOf('?')
				const path = qIndex >= 0 ? url.slice(0, qIndex) : url
				if (this.$route.path !== path) return false
				const params = new URLSearchParams(qIndex >= 0 ? url.slice(qIndex + 1) : '')
				const section = params.get('section')
				if (!section) return !this.$route.query.section
				return String(this.$route.query.section || '') === section
			},
			isGroupActive(group) {
				return (group.children || []).some((c) => this.isActiveUrl(c.url))
			},
			isGroupOpen(key) {
				return !!this.openGroups[key]
			},
			syncOpenGroups() {
				const next = Object.assign({}, this.openGroups)
				FRONT_SIDEBAR_GROUPS.forEach((g) => {
					if (this.isGroupActive(g)) next[g.key] = true
				})
				this.openGroups = next
			},
			toggleGroup(group) {
				const open = !this.openGroups[group.key]
				this.$set(this.openGroups, group.key, open)
				if (open && group.children && group.children.length === 1) {
					this.$nextTick(() => this.goChild(group.children[0].url))
				}
			},
			goChild(url) {
				this.menuOpen = false
				if (this.$route.fullPath === url) return
				this.$router.push(url)
			},
			syncMobile() {
				this.isMobile = applyMobileViewport()
				if (!this.isMobile) this.menuOpen = false
			},
			toggleMenu() {
				this.menuOpen = !this.menuOpen
			},
			closeMenu() {
				this.menuOpen = false
			},
			goUrl(e) {
				const url = e.currentTarget.dataset.url;
				const index = e.currentTarget.dataset.index;
				if (index === this.aside) return;
				this.menuOpen = false;
				this.$router.push(url);
			},
			loginOut() {
				stripElementModals()
				this.$confirm('确定退出登录吗?', '提示', {
					confirmButtonText: '退出',
					cancelButtonText: '取消',
					type: 'warning',
					customClass: 'common-logout-confirm'
				}).then(() => {
					localStorage.clear();
					this.$router.replace('/');
				}).catch(() => {});
			}
		}
	}
</script>

<style src="../../assets/css/common-shell.css"></style>
